import React, { useEffect, useState } from 'react';
import { array, object } from 'prop-types';
import { withRouter } from 'react-router';

import moment from 'moment';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { isEmpty } from 'lodash';

import BobPage from '../../../components/BobPage';
import TableContainer from './TableContainer';
import BobTimeStampFilter from '../../../components/RuleExceptionsTable/BobTimestampFilter';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import Navigation from '../Navigation/Navigation';
import { getActiveTabName } from '../Navigation/NavigationHelper';

import * as DashboardActions from '../../../actions/dashboardActions';

import classes from './CompanyPage.module.css';
import HtmlTooltip from '../../../components/HtmlTooltip/HtmlTooltip';

const CompanyPage = ({
    activeNavCompany,
    clearDashboardData,
    clientFilters,
    clientsMeta,
    companyApplications,
    companyInfo,
    companyKpis,
    dashboardEndTimeStamp,
    dashboardStartTimeStamp,
    equipmentFilters,
    equipmentMeta,
    fetchCompanyEnergyData,
    fetchDashboardCompanyKpis,
    fetchDashboardData,
    fetchDashboardEquipmentData,
    siteFilters,
    sitesMeta,
    systemFilters,
    systemsMeta,
    history,
    targetNavCompany,
    ...props
}) => {
    const [companyName, setCompanyName] = useState();
    const [activeTab, setActiveTab] = useState('');

    const queryValues = queryString.parse(history.location.search);

    useEffect(() => {
        return () => {
            clearDashboardData();
        };
    }, []);

    useEffect(() => {
        const init = async () => {
            await fetchCompanyEnergyData(activeNavCompany.id, { sort: 'default^desc', page: 1, limit: 250 });
        };

        setCompanyName(activeNavCompany.name);

        if (activeNavCompany.id) {
            init();
        }
    }, [activeNavCompany]);

    useEffect(() => {
        const init = async () => {
            let promises = [];

            if (!isEmpty(clientsMeta) && activeTab !== 'Client') {
                promises.push(fetchDashboardData(activeNavCompany.id, 'CompanyClient', { sort: 'default^desc', startDate: dashboardStartTimeStamp.format(), endDate: dashboardEndTimeStamp.format() }));
            }

            if (!isEmpty(sitesMeta) && activeTab !== 'Site') {
                promises.push(fetchDashboardData(activeNavCompany.id, 'CompanySite', { sort: 'default^desc', startDate: dashboardStartTimeStamp.format(), endDate: dashboardEndTimeStamp.format() }));
            }

            if (!isEmpty(equipmentMeta) && activeTab !== 'Equipment') {
                promises.push(fetchDashboardEquipmentData(activeNavCompany.id, 'CompanyEquipment', { sort: 'default^desc', startDate: dashboardStartTimeStamp.format(), endDate: dashboardEndTimeStamp.format() }));
            }

            if (!isEmpty(systemsMeta) && activeTab !== 'System') {
                promises.push(fetchDashboardData(activeNavCompany.id, 'CompanySystem', { sort: 'default^desc', startDate: dashboardStartTimeStamp.format(), endDate: dashboardEndTimeStamp.format() }));
            }

            await Promise.all(promises.map(p => p.catch(err => err)));
        };

        if (activeNavCompany.id) init();
    }, [activeNavCompany.id, dashboardEndTimeStamp, dashboardStartTimeStamp]);

    useEffect(() => {
        const { pathname } = history.location;
        const k2aCoreAppId = '1710345b-cf28-4a02-9bf4-df9209ff29cb';
        const bobId = 'ad356bf2-b9db-4bb5-922e-c3394b1a63e3';

        if ( !queryValues.appId) queryValues.appId = bobId; // bob
        if ( queryValues.appId === k2aCoreAppId) queryValues.appId = k2aCoreAppId; // k2aCore

        // set id's if not exist for BOB menu
        if ( queryValues.appId === bobId ) {
            if ( !queryValues.parentId) queryValues.parentId = 'ad356bf2-b9db-4bb5-922e-c3394b1a63e4';
            if ( !queryValues.childId) queryValues.childId = 'ccb00d85-7b0c-44ba-bd0e-db216ef1ee46';
        } else if ( queryValues.appId === k2aCoreAppId ) {
            if ( !queryValues.parentId) queryValues.parentId = '7e71f5d4-9fbf-4710-8601-e1f11e681479';
            if ( !queryValues.childId) queryValues.childId = '231b3d07-1afb-42a0-b6ff-ecb9c4dd8c48';
        }

        if (!queryValues.company) queryValues.company = companyInfo.companyId;

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${pathname}?${queryValuesString}`);
    }, [companyInfo]);

    const buildEntityNameTooltip = props => {
        return (
            <div>
                <div className="entityTooltipTitle">Company Information</div>
                <div className="entityTooltipHeader">Address</div>
                <div className="entityTooltipDetail">{props.companyAddress}</div>
                <div className="entityTooltipHeader">Contractor Type</div>
                <div className="entityTooltipDetail">{ props.contractorType.join(', ') }</div>
            </div>
        );
    };

    return (
        <BobPage>
            <div className={classes.CompanyPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.HeaderPanel}>
                    <div className={classes.NavigationPanel}>
                        <Navigation />
                    </div>
                    <div className={classes.Date}>
                        {
                            getActiveTabName(queryValues.appId) === 'Schedule' || getActiveTabName(queryValues.appId) === 'Service' || activeTab === 'Health Monitor' ?
                                null
                                :
                                <BobTimeStampFilter
                                    className={classes.TimestampOverride}
                                    maxDate={moment().local()}
                                    disableIntervalSelector={true}
                                />
                        }
                    </div>
                </div>
                <div className={classes.DataPanel} />
                <div className={classes.TitlePanel}>
                    <div className={classes.Name}>
                        {companyName}
                        {companyInfo.companyAddress ?
                            <HtmlTooltip
                                information={buildEntityNameTooltip(companyInfo)}
                                placement={'right-start'}
                                body={
                                    <div className={'infoIcon'}><span className="material-icons-outlined md-16" style={{cursor: 'default'}}>info</span></div>
                                }
                            />
                            : null
                        }
                    </div>
                </div>
                <div className={classes.TablePanel}>
                    <TableContainer
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                    />
                </div>
            </div>
        </BobPage>
    );
};

CompanyPage.defaultProps = {
    companyInfo:      {},
    companyKpis:      [],
    targetNavCompany: {}
};

CompanyPage.propTypes = {
    companyInfo:      object,
    companyKpis:      array,
    targetNavCompany: object
};

const mapStateToProps = state => {
    return {
        activeNavCompany:        state.bob.activeNavCompany,
        clientFilters:           state.dashboard.clientFilters,
        clientsMeta:             state.dashboard.clientsMeta,
        companyApplications:     state.bob.companyApplications,
        companyInfo:             state.companyInfo,
        companyKpis:             state.dashboard.companyKpis,
        companyTabIndex:         state.dashboard.companyTabIndex,
        dashboardEndTimeStamp:   state.dashboard.dashboardEndTimeStamp,
        dashboardStartTimeStamp: state.dashboard.dashboardStartTimeStamp,
        equipmentFilters:        state.dashboard.equipmentFilters,
        equipmentMeta:           state.dashboard.equipmentMeta,
        siteFilters:             state.dashboard.siteFilters,
        sitesMeta:               state.dashboard.sitesMeta,
        systemFilters:           state.dashboard.systemFilters,
        systemsMeta:             state.dashboard.systemsMeta,
        targetNavCompany:        state.bob.targetNavCompany
    };
};

const mapDispatchToProps = {
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyPage));
